
import { api_host, api_auth} from '../../common/globals/constants';

export const getObjectives = (user_id, token) => fetch(api_host + `/reporte/online/indicadores/ObjetivesUserList/?user=${user_id}&hash=5416d7cd6ef195a0f7622a9c56b55e84&token=${token}`)
.then(response => response.json())
